import {
  PatientDiagnosis,
  PatientDiagnosisControllerApi,
} from "../../services";
import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

/**
 * @author Rajkumar Rathod
 */
export const usePatientDiagnosesCreate = () =>
  useMutationWithLoading(
    async (params: {
      patientDiagnosis: PatientDiagnosis;
      xTENANTID?: string;
    }) =>
      new PatientDiagnosisControllerApi(
        getConfigObject()
      ).createPatientDiagnosis(params?.patientDiagnosis, params.xTENANTID)
  );
